import { render } from "./SnapchatIcon.vue?vue&type=template&id=0d8a9d07"
const script = {}
script.render = render

export default script